import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { HttpError, newHttpError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import OrderAttempt, { OrderAttemptDto } from "./OrderAttempt"

class OrderAttemptService {
    static httpClient = new HttpClient<OrderAttempt, OrderAttemptDto>(OrderAttempt)
    static async fetchOrderAttempts(priceListId) {
        const res = await this.httpClient.get(`/price-lists/order-attempts/${priceListId}`)
        return res
    }

    static async dismissOrderAttempt(orderAttemptId) {
        const res = await this.httpClient.post("/price-lists/order-attempts/dismiss", { orderAttemptId: orderAttemptId })
        return res
    }

    static async retryOrderAttempt(orderAttemptId): Promise<void | HttpError> {
        const res = await AppContext.getApiClient().post("/price-lists/order-attempts/retry", { orderAttemptId: orderAttemptId })
        if (res.error) {
            return newHttpError(res.error.message, res.error)
        }
        return res
    }
}


export default OrderAttemptService


// WEBPACK FOOTER //
// ./src/state/price-list/OrderAttemptService.ts